export const baseColors = [
  { name: 'zinc', label: 'Zinc' },
  { name: 'gray', label: 'Gray' },
  { name: 'blue', label: 'Blue' },
  { name: 'rose', label: 'Rose' },
  { name: 'red', label: 'Red' },
  { name: 'orange', label: 'Orange' },
  { name: 'yellow', label: 'Yellow' },
  { name: 'green', label: 'Green' },
  { name: 'violet', label: 'Violet' },
] as const;

export const colors = {
  inherit: 'inherit',
  current: 'currentColor',
  transparent: 'transparent',
  black: {
    hex: '#000000',
    rgb: 'rgb(0,0,0)',
    hsl: 'hsl(0,0%,0%)',
  },
  white: {
    hex: '#ffffff',
    rgb: 'rgb(255,255,255)',
    hsl: 'hsl(0,0%,100%)',
  },
  gray: [
    {
      scale: 50,
      hex: '#f9fafb',
      rgb: 'rgb(249,250,251)',
      hsl: 'hsl(210,20%,98%)',
    },
    {
      scale: 100,
      hex: '#f3f4f6',
      rgb: 'rgb(243,244,246)',
      hsl: 'hsl(220,14.3%,95.9%)',
    },
    {
      scale: 200,
      hex: '#e5e7eb',
      rgb: 'rgb(229,231,235)',
      hsl: 'hsl(220,13%,91%)',
    },
    {
      scale: 300,
      hex: '#d1d5db',
      rgb: 'rgb(209,213,219)',
      hsl: 'hsl(216,12.2%,83.9%)',
    },
    {
      scale: 400,
      hex: '#9ca3af',
      rgb: 'rgb(156,163,175)',
      hsl: 'hsl(217.9,10.6%,64.9%)',
    },
    {
      scale: 500,
      hex: '#6b7280',
      rgb: 'rgb(107,114,128)',
      hsl: 'hsl(220,8.9%,46.1%)',
    },
    {
      scale: 600,
      hex: '#4b5563',
      rgb: 'rgb(75,85,99)',
      hsl: 'hsl(215,13.8%,34.1%)',
    },
    {
      scale: 700,
      hex: '#374151',
      rgb: 'rgb(55,65,81)',
      hsl: 'hsl(216.9,19.1%,26.7%)',
    },
    {
      scale: 800,
      hex: '#1f2937',
      rgb: 'rgb(31,41,55)',
      hsl: 'hsl(215,27.9%,16.9%)',
    },
    {
      scale: 900,
      hex: '#111827',
      rgb: 'rgb(17,24,39)',
      hsl: 'hsl(220.9,39.3%,11%)',
    },
    {
      scale: 950,
      hex: '#030712',
      rgb: 'rgb(3,7,18)',
      hsl: 'hsl(224,71.4%,4.1%)',
    },
  ],
  zinc: [
    {
      scale: 50,
      hex: '#fafafa',
      rgb: 'rgb(250,250,250)',
      hsl: 'hsl(0,0%,98%)',
    },
    {
      scale: 100,
      hex: '#f4f4f5',
      rgb: 'rgb(244,244,245)',
      hsl: 'hsl(240,4.8%,95.9%)',
    },
    {
      scale: 200,
      hex: '#e4e4e7',
      rgb: 'rgb(228,228,231)',
      hsl: 'hsl(240,5.9%,90%)',
    },
    {
      scale: 300,
      hex: '#d4d4d8',
      rgb: 'rgb(212,212,216)',
      hsl: 'hsl(240,4.9%,83.9%)',
    },
    {
      scale: 400,
      hex: '#a1a1aa',
      rgb: 'rgb(161,161,170)',
      hsl: 'hsl(240,5%,64.9%)',
    },
    {
      scale: 500,
      hex: '#71717a',
      rgb: 'rgb(113,113,122)',
      hsl: 'hsl(240,3.8%,46.1%)',
    },
    {
      scale: 600,
      hex: '#52525b',
      rgb: 'rgb(82,82,91)',
      hsl: 'hsl(240,5.2%,33.9%)',
    },
    {
      scale: 700,
      hex: '#3f3f46',
      rgb: 'rgb(63,63,70)',
      hsl: 'hsl(240,5.3%,26.1%)',
    },
    {
      scale: 800,
      hex: '#27272a',
      rgb: 'rgb(39,39,42)',
      hsl: 'hsl(240,3.7%,15.9%)',
    },
    {
      scale: 900,
      hex: '#18181b',
      rgb: 'rgb(24,24,27)',
      hsl: 'hsl(240,5.9%,10%)',
    },
    {
      scale: 950,
      hex: '#09090b',
      rgb: 'rgb(9,9,11)',
      hsl: 'hsl(240,10%,3.9%)',
    },
  ],
  red: [
    {
      scale: 50,
      hex: '#fef2f2',
      rgb: 'rgb(254,242,242)',
      hsl: 'hsl(0,85.7%,97.3%)',
    },
    {
      scale: 100,
      hex: '#fee2e2',
      rgb: 'rgb(254,226,226)',
      hsl: 'hsl(0,93.3%,94.1%)',
    },
    {
      scale: 200,
      hex: '#fecaca',
      rgb: 'rgb(254,202,202)',
      hsl: 'hsl(0,96.3%,89.4%)',
    },
    {
      scale: 300,
      hex: '#fca5a5',
      rgb: 'rgb(252,165,165)',
      hsl: 'hsl(0,93.5%,81.8%)',
    },
    {
      scale: 400,
      hex: '#f87171',
      rgb: 'rgb(248,113,113)',
      hsl: 'hsl(0,90.6%,70.8%)',
    },
    {
      scale: 500,
      hex: '#ef4444',
      rgb: 'rgb(239,68,68)',
      hsl: 'hsl(0,84.2%,60.2%)',
    },
    {
      scale: 600,
      hex: '#dc2626',
      rgb: 'rgb(220,38,38)',
      hsl: 'hsl(0,72.2%,50.6%)',
    },
    {
      scale: 700,
      hex: '#b91c1c',
      rgb: 'rgb(185,28,28)',
      hsl: 'hsl(0,73.7%,41.8%)',
    },
    {
      scale: 800,
      hex: '#991b1b',
      rgb: 'rgb(153,27,27)',
      hsl: 'hsl(0,70%,35.3%)',
    },
    {
      scale: 900,
      hex: '#7f1d1d',
      rgb: 'rgb(127,29,29)',
      hsl: 'hsl(0,62.8%,30.6%)',
    },
    {
      scale: 950,
      hex: '#450a0a',
      rgb: 'rgb(69,10,10)',
      hsl: 'hsl(0,74.7%,15.5%)',
    },
  ],
  orange: [
    {
      scale: 50,
      hex: '#fff7ed',
      rgb: 'rgb(255,247,237)',
      hsl: 'hsl(33.3,100%,96.5%)',
    },
    {
      scale: 100,
      hex: '#ffedd5',
      rgb: 'rgb(255,237,213)',
      hsl: 'hsl(34.3,100%,91.8%)',
    },
    {
      scale: 200,
      hex: '#fed7aa',
      rgb: 'rgb(254,215,170)',
      hsl: 'hsl(32.1,97.7%,83.1%)',
    },
    {
      scale: 300,
      hex: '#fdba74',
      rgb: 'rgb(253,186,116)',
      hsl: 'hsl(30.7,97.2%,72.4%)',
    },
    {
      scale: 400,
      hex: '#fb923c',
      rgb: 'rgb(251,146,60)',
      hsl: 'hsl(27,96%,61%)',
    },
    {
      scale: 500,
      hex: '#f97316',
      rgb: 'rgb(249,115,22)',
      hsl: 'hsl(24.6,95%,53.1%)',
    },
    {
      scale: 600,
      hex: '#ea580c',
      rgb: 'rgb(234,88,12)',
      hsl: 'hsl(20.5,90.2%,48.2%)',
    },
    {
      scale: 700,
      hex: '#c2410c',
      rgb: 'rgb(194,65,12)',
      hsl: 'hsl(17.5,88.3%,40.4%)',
    },
    {
      scale: 800,
      hex: '#9a3412',
      rgb: 'rgb(154,52,18)',
      hsl: 'hsl(15,79.1%,33.7%)',
    },
    {
      scale: 900,
      hex: '#7c2d12',
      rgb: 'rgb(124,45,18)',
      hsl: 'hsl(15.3,74.6%,27.8%)',
    },
    {
      scale: 950,
      hex: '#431407',
      rgb: 'rgb(67,20,7)',
      hsl: 'hsl(13,81.1%,14.5%)',
    },
  ],
  yellow: [
    {
      scale: 50,
      hex: '#fefce8',
      rgb: 'rgb(254,252,232)',
      hsl: 'hsl(54.5,91.7%,95.3%)',
    },
    {
      scale: 100,
      hex: '#fef9c3',
      rgb: 'rgb(254,249,195)',
      hsl: 'hsl(54.9,96.7%,88%)',
    },
    {
      scale: 200,
      hex: '#fef08a',
      rgb: 'rgb(254,240,138)',
      hsl: 'hsl(52.8,98.3%,76.9%)',
    },
    {
      scale: 300,
      hex: '#fde047',
      rgb: 'rgb(253,224,71)',
      hsl: 'hsl(50.4,97.8%,63.5%)',
    },
    {
      scale: 400,
      hex: '#facc15',
      rgb: 'rgb(250,204,21)',
      hsl: 'hsl(47.9,95.8%,53.1%)',
    },
    {
      scale: 500,
      hex: '#eab308',
      rgb: 'rgb(234,179,8)',
      hsl: 'hsl(45.4,93.4%,47.5%)',
    },
    {
      scale: 600,
      hex: '#ca8a04',
      rgb: 'rgb(202,138,4)',
      hsl: 'hsl(40.6,96.1%,40.4%)',
    },
    {
      scale: 700,
      hex: '#a16207',
      rgb: 'rgb(161,98,7)',
      hsl: 'hsl(35.5,91.7%,32.9%)',
    },
    {
      scale: 800,
      hex: '#854d0e',
      rgb: 'rgb(133,77,14)',
      hsl: 'hsl(31.8,81%,28.8%)',
    },
    {
      scale: 900,
      hex: '#713f12',
      rgb: 'rgb(113,63,18)',
      hsl: 'hsl(28.4,72.5%,25.7%)',
    },
    {
      scale: 950,
      hex: '#422006',
      rgb: 'rgb(66,32,6)',
      hsl: 'hsl(26,83.3%,14.1%)',
    },
  ],
  green: [
    {
      scale: 50,
      hex: '#f0fdf4',
      rgb: 'rgb(240,253,244)',
      hsl: 'hsl(138.5,76.5%,96.7%)',
    },
    {
      scale: 100,
      hex: '#dcfce7',
      rgb: 'rgb(220,252,231)',
      hsl: 'hsl(140.6,84.2%,92.5%)',
    },
    {
      scale: 200,
      hex: '#bbf7d0',
      rgb: 'rgb(187,247,208)',
      hsl: 'hsl(141,78.9%,85.1%)',
    },
    {
      scale: 300,
      hex: '#86efac',
      rgb: 'rgb(134,239,172)',
      hsl: 'hsl(141.7,76.6%,73.1%)',
    },
    {
      scale: 400,
      hex: '#4ade80',
      rgb: 'rgb(74,222,128)',
      hsl: 'hsl(141.9,69.2%,58%)',
    },
    {
      scale: 500,
      hex: '#22c55e',
      rgb: 'rgb(34,197,94)',
      hsl: 'hsl(142.1,70.6%,45.3%)',
    },
    {
      scale: 600,
      hex: '#16a34a',
      rgb: 'rgb(22,163,74)',
      hsl: 'hsl(142.1,76.2%,36.3%)',
    },
    {
      scale: 700,
      hex: '#15803d',
      rgb: 'rgb(21,128,61)',
      hsl: 'hsl(142.4,71.8%,29.2%)',
    },
    {
      scale: 800,
      hex: '#166534',
      rgb: 'rgb(22,101,52)',
      hsl: 'hsl(142.8,64.2%,24.1%)',
    },
    {
      scale: 900,
      hex: '#14532d',
      rgb: 'rgb(20,83,45)',
      hsl: 'hsl(143.8,61.2%,20.2%)',
    },
    {
      scale: 950,
      hex: '#052e16',
      rgb: 'rgb(5,46,22)',
      hsl: 'hsl(144.9,80.4%,10%)',
    },
  ],
  blue: [
    {
      scale: 50,
      hex: '#eff6ff',
      rgb: 'rgb(239,246,255)',
      hsl: 'hsl(213.8,100%,96.9%)',
    },
    {
      scale: 100,
      hex: '#dbeafe',
      rgb: 'rgb(219,234,254)',
      hsl: 'hsl(214.3,94.6%,92.7%)',
    },
    {
      scale: 200,
      hex: '#bfdbfe',
      rgb: 'rgb(191,219,254)',
      hsl: 'hsl(213.3,96.9%,87.3%)',
    },
    {
      scale: 300,
      hex: '#93c5fd',
      rgb: 'rgb(147,197,253)',
      hsl: 'hsl(211.7,96.4%,78.4%)',
    },
    {
      scale: 400,
      hex: '#60a5fa',
      rgb: 'rgb(96,165,250)',
      hsl: 'hsl(213.1,93.9%,67.8%)',
    },
    {
      scale: 500,
      hex: '#3b82f6',
      rgb: 'rgb(59,130,246)',
      hsl: 'hsl(217.2,91.2%,59.8%)',
    },
    {
      scale: 600,
      hex: '#2563eb',
      rgb: 'rgb(37,99,235)',
      hsl: 'hsl(221.2,83.2%,53.3%)',
    },
    {
      scale: 700,
      hex: '#1d4ed8',
      rgb: 'rgb(29,78,216)',
      hsl: 'hsl(224.3,76.3%,48%)',
    },
    {
      scale: 800,
      hex: '#1e40af',
      rgb: 'rgb(30,64,175)',
      hsl: 'hsl(225.9,70.7%,40.2%)',
    },
    {
      scale: 900,
      hex: '#1e3a8a',
      rgb: 'rgb(30,58,138)',
      hsl: 'hsl(224.4,64.3%,32.9%)',
    },
    {
      scale: 950,
      hex: '#172554',
      rgb: 'rgb(23,37,84)',
      hsl: 'hsl(226.2,57%,21%)',
    },
  ],
  violet: [
    {
      scale: 50,
      hex: '#f5f3ff',
      rgb: 'rgb(245,243,255)',
      hsl: 'hsl(250,100%,97.6%)',
    },
    {
      scale: 100,
      hex: '#ede9fe',
      rgb: 'rgb(237,233,254)',
      hsl: 'hsl(251.4,91.3%,95.5%)',
    },
    {
      scale: 200,
      hex: '#ddd6fe',
      rgb: 'rgb(221,214,254)',
      hsl: 'hsl(250.5,95.2%,91.8%)',
    },
    {
      scale: 300,
      hex: '#c4b5fd',
      rgb: 'rgb(196,181,253)',
      hsl: 'hsl(252.5,94.7%,85.1%)',
    },
    {
      scale: 400,
      hex: '#a78bfa',
      rgb: 'rgb(167,139,250)',
      hsl: 'hsl(255.1,91.7%,76.3%)',
    },
    {
      scale: 500,
      hex: '#8b5cf6',
      rgb: 'rgb(139,92,246)',
      hsl: 'hsl(258.3,89.5%,66.3%)',
    },
    {
      scale: 600,
      hex: '#7c3aed',
      rgb: 'rgb(124,58,237)',
      hsl: 'hsl(262.1,83.3%,57.8%)',
    },
    {
      scale: 700,
      hex: '#6d28d9',
      rgb: 'rgb(109,40,217)',
      hsl: 'hsl(263.4,70%,50.4%)',
    },
    {
      scale: 800,
      hex: '#5b21b6',
      rgb: 'rgb(91,33,182)',
      hsl: 'hsl(263.4,69.3%,42.2%)',
    },
    {
      scale: 900,
      hex: '#4c1d95',
      rgb: 'rgb(76,29,149)',
      hsl: 'hsl(263.5,67.4%,34.9%)',
    },
    {
      scale: 950,
      hex: '#1e1b4b',
      rgb: 'rgb(46,16,101)',
      hsl: 'hsl(261.2,72.6%,22.9%)',
    },
  ],
  rose: [
    {
      scale: 50,
      hex: '#fff1f2',
      rgb: 'rgb(255,241,242)',
      hsl: 'hsl(355.7,100%,97.3%)',
    },
    {
      scale: 100,
      hex: '#ffe4e6',
      rgb: 'rgb(255,228,230)',
      hsl: 'hsl(355.6,100%,94.7%)',
    },
    {
      scale: 200,
      hex: '#fecdd3',
      rgb: 'rgb(254,205,211)',
      hsl: 'hsl(352.7,96.1%,90%)',
    },
    {
      scale: 300,
      hex: '#fda4af',
      rgb: 'rgb(253,164,175)',
      hsl: 'hsl(352.6,95.7%,81.8%)',
    },
    {
      scale: 400,
      hex: '#fb7185',
      rgb: 'rgb(251,113,133)',
      hsl: 'hsl(351.3,94.5%,71.4%)',
    },
    {
      scale: 500,
      hex: '#f43f5e',
      rgb: 'rgb(244,63,94)',
      hsl: 'hsl(349.7,89.2%,60.2%)',
    },
    {
      scale: 600,
      hex: '#e11d48',
      rgb: 'rgb(225,29,72)',
      hsl: 'hsl(346.8,77.2%,49.8%)',
    },
    {
      scale: 700,
      hex: '#be123c',
      rgb: 'rgb(190,18,60)',
      hsl: 'hsl(345.3,82.7%,40.8%)',
    },
    {
      scale: 800,
      hex: '#9f1239',
      rgb: 'rgb(159,18,57)',
      hsl: 'hsl(343.4,79.7%,34.7%)',
    },
    {
      scale: 900,
      hex: '#881337',
      rgb: 'rgb(136,19,55)',
      hsl: 'hsl(341.5,75.5%,30.4%)',
    },
    {
      scale: 950,
      hex: '#4c0519',
      rgb: 'rgb(76,5,25)',
      hsl: 'hsl(343.1,87.7%,15.9%)',
    },
  ],
};

export const colorMapping = {
  light: {
    'background': 'white',
    'foreground': '{{base}}-950',
    'card': 'white',
    'card-foreground': '{{base}}-950',
    'popover': 'white',
    'popover-foreground': '{{base}}-950',
    'primary': '{{base}}-900',
    'primary-foreground': '{{base}}-50',
    'secondary': '{{base}}-100',
    'secondary-foreground': '{{base}}-900',
    'muted': '{{base}}-100',
    'muted-foreground': '{{base}}-500',
    'accent': '{{base}}-100',
    'accent-foreground': '{{base}}-900',
    'destructive': 'red-500',
    'destructive-foreground': '{{base}}-50',
    'border': '{{base}}-200',
    'input': '{{base}}-200',
    'ring': '{{base}}-950',
  },
  dark: {
    'background': '{{base}}-950',
    'foreground': '{{base}}-50',
    'card': '{{base}}-950',
    'card-foreground': '{{base}}-50',
    'popover': '{{base}}-950',
    'popover-foreground': '{{base}}-50',
    'primary': '{{base}}-50',
    'primary-foreground': '{{base}}-900',
    'secondary': '{{base}}-800',
    'secondary-foreground': '{{base}}-50',
    'muted': '{{base}}-800',
    'muted-foreground': '{{base}}-400',
    'accent': '{{base}}-800',
    'accent-foreground': '{{base}}-50',
    'destructive': 'red-900',
    'destructive-foreground': '{{base}}-50',
    'border': '{{base}}-800',
    'input': '{{base}}-800',
    'ring': '{{base}}-300',
  },
} as const;
